import { Injectable } from '@angular/core';
import { DefaultSingleConnectionPrepareProcessor } from './default-single-connection-prepare.processor';
import { DefaultMultipleConnectionPrepareProcessor } from './default-multiple-connection-prepare.processor';
import { EndPlateArticlePrepareProcessor } from './end-plate-article-prepare.processor';
import { ArticlePrepareProcessorRegistry } from './article-prepare-processor-registry';

@Injectable({providedIn: 'root'})
export class ArticlePrepareProcessorRegistryInitializer {

  constructor(
    private articlePrepareProcessorRegistry: ArticlePrepareProcessorRegistry,
    private defaultSinglePrepareProcessor: DefaultSingleConnectionPrepareProcessor,
    private defaultMultiplePrepareProcessor: DefaultMultipleConnectionPrepareProcessor,
    private endPlatePrepareProcessor: EndPlateArticlePrepareProcessor
  ) {}

  public initialize() {
    this.articlePrepareProcessorRegistry.initialize(this.defaultSinglePrepareProcessor, this.defaultMultiplePrepareProcessor, this.endPlatePrepareProcessor);
  }
}
